import { GetDocumentTypeDto } from 'src/app/modules/doc-types/models/doc-types.model';
import { DocumentProcessingPagedReviewResponse } from 'src/app/modules/documents/services/document-processing-api.service';
import { LanguageDto } from 'src/app/shared/services/languages-api.service';
import {
	AnalyzeClauseVarianceResponseDto,
	WorkspaceDocumentDto,
} from '../../models/workspaces.model';
import { ClauseVarianceDetailedExportState } from './services/clause-variance-export-state.service';

export interface ClauseAlignmentRowViewModel {
	clauseId: number;
	clauseName: string;
	documentStatuses: (ClauseAlignmentStatus | null)[];
}

export interface DetailedFilterModel {
	clauseName: string | null;
	targetDocumentId: string | null;
	legalEquivalence: string | null;
}

export enum ClauseAlignmentStatus {
	Yes = 'yes',
	No = 'no',
}

export enum DetailedClauseAlignmentStatus {
	Yes = 'yes',
	No = 'no',
}

export enum ClauseVarianceExportType {
	Full = 'full',
	Filtered = 'filtered',
}

export interface ClauseVariancePdfContext {
	exportType: ClauseVarianceExportType;
	workspaceName: string;
	selectedReferenceDocument: WorkspaceDocumentDto | null;
	nonReferenceDocuments: WorkspaceDocumentDto[];
	analyzingClauseVarianceResponse: AnalyzeClauseVarianceResponseDto | null;
	pagedReviewDataByDocumentId: Record<string, DocumentProcessingPagedReviewResponse>;
	reviewedPagesByDocumentId: Record<string, number>;
	totalPagesByDocumentId: Record<string, number>;
	contentLanguages: LanguageDto[];
	docTypes: GetDocumentTypeDto[];
	totalReviewPagesAllDocuments: number;
	totalReviewedPagesAllDocuments: number;
	loadingReviewDataComplete: boolean;
	reviewDoneWithErrors: boolean;
	detailedExportState: ClauseVarianceDetailedExportState;
}
